import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormArray, FormBuilder, FormControl } from "@angular/forms";
import { MediaService, UtilityService } from "services";
import { take } from "rxjs/operators";
import { GfcService } from "adminModules/gfc/gfc.service";
import { AddPlantComponent } from "adminModules/city-facilities/plant/add-plant.component";

@Component({
  selector: "app-file-input",
  templateUrl: "./file-input.component.html",
  styles: [
    ".hint{font-size:0.8rem; opacity:0.7} .red{font-size: 11px; padding: 0.3rem 0.8rem}",
  ],
})
export class FileInputComponent implements OnChanges {
  @Input() label;
  @Input() accept = "image/*";
  @Input() type = "Image";
  @Input() hint = "";
  @Input() service = "";
  @Input() isEditable = false;
  @Input() baseUrl = "media";
  @Input() isRemoveFromAPI = false;
  @Input() control: FormControl;
  @Output() triggerRemove = new EventEmitter<any>();
  @ViewChild("file") fileInput: ElementRef;
  @Input() fileSize = "10";
  @Input() hideClose = false;
  @Input() view;
  @Input() mediaType = "";
  @Input() index;

  cheeckValid: boolean = false;
  fileControl = new FormControl();
  constructor(
    private util: UtilityService,
    private media: MediaService,
    private gfc: GfcService,
    private fb: FormBuilder,
  ) {}

  onSelectedFile(event) {
    // this.control.markAllAsTouched();
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      //adedd below code......
      if (file.size != 0) {
        let fileSizeLimit;
        const maxSizeInMB = parseInt(this.fileSize); // Adjust this value as needed
        const maxSizeInBytes = 10485760;
        if (this.fileSize) {
          fileSizeLimit = this.fileSize;
        } else {
          fileSizeLimit = 10;
        }

        let extensions;
        if (this.type === "video") {
          extensions = [".mp4", ".3gp", ".webm", ".flv", ".mov"];
        } else {
          extensions = [".jpg", ".jpeg", ".png", ".pdf"];
        }
        // console.log("file.type :::", file.type);
        const fileExtension = file.name
          .toLowerCase()
          .slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);
        if (file.size >= fileSizeLimit * 1048576) {
          this.control.setValue("");
          this.fileControl.setValue("");
          return this.util.showMsg(
            `File size must be ${fileSizeLimit} MB or less.`,
            ""
          );
        } else if (!extensions.includes(`.${fileExtension}`)) {
          this.control.setValue("");
          this.fileControl.setValue("");
          this.util.showMsg(
            `Please select file type (${extensions.join(", ")}) only.`,
            ""
          );
        } else {
          if (
            file.type == "image/jpg" ||
            file.type == "image/png" ||
            file.type == "image/jpeg" ||
            file.type == "video/mp4" ||
            file.type == "video/3gp" ||
            file.type == "video/webm" ||
            file.type == "video/flv" ||
            file.type == "video/mov"
          ) {
            this.gfc
              .uploadSingleImageByFolder(formData, { isLive: this.hideClose })
              .subscribe(
                (res) => {
                  // Handle the response from this API call
                  if (res.data) {
                    console.log(res.data);
                    this.control.setValue(res.data);
                  } else {
                    this.util.showMsg("Something went Wrong", "Error");
                  }
                },
                (err) => {
                  this.util.errorMessage(err);
                }
              );
          } else if (file.type == "application/pdf") {
            this.defaultMethod(formData);
          } else {
            if (file.size >= 10485760) {
              return this.util.errorMessage("File size must be 10 MB or less.");
            } else {
              return this.util.errorMessage(
                "Upload pdf/image file of less than 10 MB is required"
              );
            }
          }
        }
      }
      // this.defaultMethod(formData);}
    } else {
      this.control.setValue("");
      this.fileControl.touched;
    }
  }

  // Define your default method if fileSize is not provided
  defaultMethod(formData) {
    console.log("formData", formData);
    this.media
      .uploadSingle(formData, this.service ? { service: this.service } : {})
      .subscribe(
        (res) => {
          if (res.data) {
            this.control.setValue(res.data);
          } else {
            this.util.showMsg("Something went Wrong", "Error");
          }
        },
        (err) => {
          this.util.errorMessage(err);
        }
      );
    return;
  }
  bannerPreview(type, data) {
    console.log(this.index);
    if (type == "Image") {
      this.util.preview(
        type,
        data?.controls.map((i) => i.value.url).filter((x) => x)
      );
    }
    if (type == "Video") {
      const videoData = data?.controls
        .map((i) => i.value.url)
        .filter((x) => x);

      this.util.preview(type, videoData[this.index]);
    }
  }
  downloadFile() {
    console.log("hi");
    if (this.control.value) {
      const file = this.control.value?.media;
      if (!file) {
        return this.util.showError("File Not Found");
      } else {
        // let mediaArray = this.view as FormArray;
        // if (mediaArray.controls.length != 0) {
        //   this.bannerPreview();
        // }
        if (this.fileSize) {
          // console.log("hi1");
          this.gfc.getuploadImageByFolder(file).subscribe((res) => {
            this.downloadSingleFile(res.data, "");
          });
        } else {
          // console.log("hi");
          return this.media.viewFile(file, this.service);
        }
      }
    }
  }

  downloadFileView() {
    if (this.control.value) {
      const file = this.control.value?.media;
      if (!file) {
        return this.util.showError("File Not Found");
      } else if (this.view instanceof FormArray) {
        let mediaArray = this.view as FormArray;
        if (mediaArray.controls.length != 0) {
          this.bannerPreview(this.mediaType, mediaArray);
        } else {
          return this.media.viewFile(file, this.service);
        }
      } else {
        let mediaArray = this.fb.array([this.view as FormControl]);
        if (mediaArray.controls.length != 0) {
          this.bannerPreview(this.mediaType, mediaArray);
        } else {
          return this.media.viewFile(file, this.service);
        }
      }
    }
  }
  ngOnChanges() {
    if (this.fileInput) {
      if (this.isEditable) {
        this.fileInput.nativeElement.disabled = false;
      } else {
        this.fileInput.nativeElement.disabled = true;
      }
    }
  }
  isRequired(): boolean {
    return this.control.hasError("required") && this.control.touched;
  }
  removeFile() {
    this.util
      .confirm(
        `Remove ${this.type}`,
        `Are you sure want to remove this ${this.type}?`
      )
      .pipe(take(1))
      .subscribe((confirmed) => {
        if (confirmed) {
          this.remove();
        }
      });
  }
  remove() {
    if (this.control && this.isRemoveFromAPI) {
      this.triggerRemove.emit();
    }
    this.control.setValue("");
  }

  /// added this
  downloadSingleFile(fileName, content) {
    const blob = new Blob([fileName], { type: "application/images" });
    const url = fileName;
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.target = "_blank";
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }
}
